import { ErrorCodes } from 'enums';

export class UserNotFoundError extends Error {
  code: ErrorCodes = ErrorCodes.USER_NOT_FOUND;

  constructor() {
    super('Usuário não autenticado.');
    this.name = 'UserNotFoundError';

    return this;
  }
}
